<template>
  <div class="wrapper">
    <MainPanel />
    <LeftPanel />
    <GamePanel id="game" />
    <TimerClock ref="clock" />
    <Tutorial ref="tutorial" />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';

import {
  GameAppStartEvent,
  ShowTimerClockEvent,
  StartTutorialEvent
} from '@/app-events';
import EventBus from '@/plugin/vue-event-bus';

const MainPanel = defineAsyncComponent(
  () => import('@/components/MainPanel.vue')
);
const LeftPanel = defineAsyncComponent(
  () => import('@/components/LeftPanel.vue')
);
const GamePanel = defineAsyncComponent(
  () => import('@/components/GamePanel.vue')
);
const TimerClock = defineAsyncComponent(
  () => import('@/components/TimerClock.vue')
);
const Tutorial = defineAsyncComponent(
  () => import('@/components/Tutorial.vue')
);

export default {
  name: 'game',
  components: { MainPanel, LeftPanel, GamePanel, TimerClock, Tutorial },
  destroyed() {
    // remove event handlers when destroyed
    EventBus.remove(GameAppStartEvent, this.gameAppStart);
    EventBus.remove(ShowTimerClockEvent, this.showTimerClock);
    EventBus.remove(StartTutorialEvent, this.startTutorial);

    document.removeEventListener('mousemove', this.mouseMoveHandler);
  },
  mounted() {
    this.$store.dispatch('getPrincipalStats');
    // register events
    EventBus.listen(GameAppStartEvent, this.gameAppStart);
    EventBus.listen(ShowTimerClockEvent, this.showTimerClock);
    EventBus.listen(StartTutorialEvent, this.startTutorial);

    document.addEventListener('mousemove', this.mouseMoveHandler);
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },
  data() {
    return {
      resizeObserver: null
    };
  },
  methods: {
    gameAppStart() {
      let topPanel = document.querySelector('.top-panel');
      let leftPanel = document.querySelector('.left-panel');
      // let helpPanel = document.querySelector('.help-panel')

      setTimeout(() => {
        leftPanel.style.bottom = '0px';
        setTimeout(() => {
          const handleResize = (entries) => {
            let leftPanelPad = 20;
            if (window.innerWidth <= 1440) {
              leftPanelPad = 0;
            }
            for (const entry of entries) {
              if (entry.target === leftPanel) {
                const newWidth = entry.contentRect.width;
                topPanel.style.left = `${newWidth + leftPanelPad}px`;
              }
            }
          };
          this.resizeObserver = new ResizeObserver(handleResize);
          this.resizeObserver.observe(leftPanel);
        }, 1000);
      }, 1000);
    },
    mouseMoveHandler(e) {
      e = e || window.event;
      let pageX = e.pageX;
      let pageY = e.pageY;
      // IE 8
      if (pageX === undefined) {
        pageX =
          e.clientX +
          document.body.scrollLeft +
          document.documentElement.scrollLeft;
        pageY =
          e.clientY +
          document.body.scrollTop +
          document.documentElement.scrollTop;
      }
      if (this.$refs.clock && this.$refs.clock.$el) {
        this.$refs.clock.$el.style.top = pageY - 20 + 'px';
        this.$refs.clock.$el.style.left = pageX - 20 + 'px';
      }
    },
    showTimerClock(e) {
      this.$refs.clock.show(e.time);
    },
    startTutorial() {
      this.$refs.tutorial.start();
    }
  }
};
</script>

<style scoped>
.wrapper {
  display: flex;
  height: 100%;
}
</style>
